// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscriptionDetailsCard_subscriptionCard__3HYJ9 {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(153, 153, 153, 0) 100%);
  border-radius: 16px;
  padding: 16px 20px;
  width: 328px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.subscriptionDetailsCard_timelineContainer__QdDUF {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.subscriptionDetailsCard_timelineContent__zgmY3 {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.subscriptionDetailsCard_timelineItem__0zz0q {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  position: relative;
  padding-bottom: 20px;
}

.subscriptionDetailsCard_timelineItem__0zz0q:last-child {
  padding-bottom: 0;
}

.subscriptionDetailsCard_timelineDot__34rf6 {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
  position: relative;
  margin-top: 6px;
  z-index: 2;
}

.subscriptionDetailsCard_timelineDot__34rf6[data-status="active"] {
  background: #2BCB44;
}

.subscriptionDetailsCard_timelineDot__34rf6[data-status="inactive"] {
  background: #8D93A8;
}

.subscriptionDetailsCard_timelineDot__34rf6[data-status="active"]::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 7px;
  transform: translateX(-50%);
  width: 1px;
  height: 42px;
  z-index: 1;
  background: #2BCB44;
}

.subscriptionDetailsCard_timelineItem__0zz0q:last-child .subscriptionDetailsCard_timelineDot__34rf6::before,
.subscriptionDetailsCard_timelineItemGroup__ks5S8 .subscriptionDetailsCard_timelineItem__0zz0q .subscriptionDetailsCard_timelineDot__34rf6::before {
  display: none !important;
}

.subscriptionDetailsCard_timelineItem__0zz0q:has(+ .subscriptionDetailsCard_timelineItem__0zz0q [data-status="inactive"]) .subscriptionDetailsCard_timelineDot__34rf6[data-status="active"]::before,
.subscriptionDetailsCard_timelineItem__0zz0q:has(+ .subscriptionDetailsCard_timelineItemGroup__ks5S8 [data-status="inactive"]) .subscriptionDetailsCard_timelineDot__34rf6[data-status="active"]::before {
  background: linear-gradient(to bottom, #2BCB44 0%, #8D93A8 100%);
}

.subscriptionDetailsCard_timelineText__vgQxD {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 1;
  min-width: 0;
}

.subscriptionDetailsCard_timelineItemGroup__ks5S8 {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
}

.subscriptionDetailsCard_timelineItemGroup__ks5S8 .subscriptionDetailsCard_timelineItem__0zz0q {
  padding-bottom: 0;
}

.subscriptionDetailsCard_timelineItemGroup__ks5S8 .subscriptionDetailsCard_subscriptionInfo__sE-5k {
  padding-left: 15px;
  margin: 0;
}

.subscriptionDetailsCard_timelineItemGroup__ks5S8 .subscriptionDetailsCard_subscriptionInfo__sE-5k p {
  margin: 0;
  padding: 0;
}

.subscriptionDetailsCard_timelineLabel__\\+brJN {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #2bcb44;
  white-space: nowrap;
}

.subscriptionDetailsCard_timelineAmount__8Dkko {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #2bcb44;
  white-space: nowrap;
}

.subscriptionDetailsCard_timelineLabelInactive__h-Tmk {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #8D93A8;
  white-space: nowrap;
}

.subscriptionDetailsCard_timelineAmountInactive__AEo7w {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #8D93A8;
  text-align: right;
  white-space: nowrap;
}

.subscriptionDetailsCard_subscriptionInfo__sE-5k {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #8D93A8;
  margin: 0;
  padding: 0;
}

.subscriptionDetailsCard_divider__p0m8F {
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0) 100%);
}

.subscriptionDetailsCard_autopayInfo__jeFjl {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  width: 100%;
}

.subscriptionDetailsCard_autopayText__aorIT {
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: center;
  text-align: center;
  white-space: nowrap;
}

.subscriptionDetailsCard_autopayLabel__26Uvc {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #9396a3;
}

.subscriptionDetailsCard_cancelAnytime__1Gjga {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #fa9805;
}

.subscriptionDetailsCard_notificationText__fVmIR {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #9396a3;
  text-align: center;
  margin: 0;
  white-space: pre-wrap;
}



`, "",{"version":3,"sources":["webpack://./src/components/SubscriptionDetailsCard/subscriptionDetailsCard.module.css"],"names":[],"mappings":"AAAA;EACE,6FAA6F;EAC7F,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,gEAAgE;AAClE;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,wHAAwH;AAC1H;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,qBAAqB;AACvB","sourcesContent":[".subscriptionCard {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(153, 153, 153, 0) 100%);\n  border-radius: 16px;\n  padding: 16px 20px;\n  width: 328px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.timelineContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.timelineContent {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.timelineItem {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  width: 100%;\n  position: relative;\n  padding-bottom: 20px;\n}\n\n.timelineItem:last-child {\n  padding-bottom: 0;\n}\n\n.timelineDot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  position: relative;\n  margin-top: 6px;\n  z-index: 2;\n}\n\n.timelineDot[data-status=\"active\"] {\n  background: #2BCB44;\n}\n\n.timelineDot[data-status=\"inactive\"] {\n  background: #8D93A8;\n}\n\n.timelineDot[data-status=\"active\"]::before {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 7px;\n  transform: translateX(-50%);\n  width: 1px;\n  height: 42px;\n  z-index: 1;\n  background: #2BCB44;\n}\n\n.timelineItem:last-child .timelineDot::before,\n.timelineItemGroup .timelineItem .timelineDot::before {\n  display: none !important;\n}\n\n.timelineItem:has(+ .timelineItem [data-status=\"inactive\"]) .timelineDot[data-status=\"active\"]::before,\n.timelineItem:has(+ .timelineItemGroup [data-status=\"inactive\"]) .timelineDot[data-status=\"active\"]::before {\n  background: linear-gradient(to bottom, #2BCB44 0%, #8D93A8 100%);\n}\n\n.timelineText {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex: 1;\n  min-width: 0;\n}\n\n.timelineItemGroup {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 12px;\n}\n\n.timelineItemGroup .timelineItem {\n  padding-bottom: 0;\n}\n\n.timelineItemGroup .subscriptionInfo {\n  padding-left: 15px;\n  margin: 0;\n}\n\n.timelineItemGroup .subscriptionInfo p {\n  margin: 0;\n  padding: 0;\n}\n\n.timelineLabel {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #2bcb44;\n  white-space: nowrap;\n}\n\n.timelineAmount {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #2bcb44;\n  white-space: nowrap;\n}\n\n.timelineLabelInactive {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #8D93A8;\n  white-space: nowrap;\n}\n\n.timelineAmountInactive {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #8D93A8;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.subscriptionInfo {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #8D93A8;\n  margin: 0;\n  padding: 0;\n}\n\n.divider {\n  width: 100%;\n  height: 1px;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0) 100%);\n}\n\n.autopayInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: center;\n  width: 100%;\n}\n\n.autopayText {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.autopayLabel {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #9396a3;\n}\n\n.cancelAnytime {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #fa9805;\n}\n\n.notificationText {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #9396a3;\n  text-align: center;\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subscriptionCard": `subscriptionDetailsCard_subscriptionCard__3HYJ9`,
	"timelineContainer": `subscriptionDetailsCard_timelineContainer__QdDUF`,
	"timelineContent": `subscriptionDetailsCard_timelineContent__zgmY3`,
	"timelineItem": `subscriptionDetailsCard_timelineItem__0zz0q`,
	"timelineDot": `subscriptionDetailsCard_timelineDot__34rf6`,
	"timelineItemGroup": `subscriptionDetailsCard_timelineItemGroup__ks5S8`,
	"timelineText": `subscriptionDetailsCard_timelineText__vgQxD`,
	"subscriptionInfo": `subscriptionDetailsCard_subscriptionInfo__sE-5k`,
	"timelineLabel": `subscriptionDetailsCard_timelineLabel__+brJN`,
	"timelineAmount": `subscriptionDetailsCard_timelineAmount__8Dkko`,
	"timelineLabelInactive": `subscriptionDetailsCard_timelineLabelInactive__h-Tmk`,
	"timelineAmountInactive": `subscriptionDetailsCard_timelineAmountInactive__AEo7w`,
	"divider": `subscriptionDetailsCard_divider__p0m8F`,
	"autopayInfo": `subscriptionDetailsCard_autopayInfo__jeFjl`,
	"autopayText": `subscriptionDetailsCard_autopayText__aorIT`,
	"autopayLabel": `subscriptionDetailsCard_autopayLabel__26Uvc`,
	"cancelAnytime": `subscriptionDetailsCard_cancelAnytime__1Gjga`,
	"notificationText": `subscriptionDetailsCard_notificationText__fVmIR`
};
export default ___CSS_LOADER_EXPORT___;
